module.exports = __webpack_public_path__ + "img/img-soporte-tecnico.e2590bd2.png";